import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Rect, Svg } from 'react-native-svg';

export interface AfterpayBadgeIconProps extends SvgProps {
  width?: number;
  height?: number;
  selected?: boolean;
}

// Afterpay's brand green, sampled from the official logo kit. Fixed and
// theme-independent — Afterpay's guidelines don't offer a dark-mode variant,
// and selection state doesn't change this tile's color.
const AFTERPAY_GREEN = '#00D64F';

// Traced from Afterpay's official icon mark (brand kit SVG) — the $ glyph's
// own path, cropped to its bounding box within the source artwork.
const DOLLAR_GLYPH_PATH =
  'M539.9865723,451.4339294c105.2737427,22.5762329,153.397583,66.2222595,153.397583,139.971405c0,92.4550781-75.223999,160.7011108-192.6532593,167.9244385l-11.4581604,54.6863403c-1.1200256,5.3450928-5.8311157,9.1742554-11.2880859,9.1742554h-90.341217c-7.4444275,0-12.9402466-6.9561157-11.2200623-14.2060547l14.5000916-61.1564331c-58.2092896-16.5750122-105.047821-48.8162842-132.3520813-88.6137695c-3.4379578-5.0123291-2.2984314-11.8566284,2.4952393-15.588501l63.1462708-49.1516113c5.2018433-4.0502319,12.663269-2.864502,16.5093689,2.4952393c33.460968,46.6053467,84.7919617,74.2059937,146.6286316,74.2059937c55.6435547,0,97.7516479-27.0904541,97.7516479-66.222229c0-30.1031494-21.0528564-43.6484375-91.7358398-58.7000122C371.54953,520.6665039,323.4256897,475.5140991,323.4256897,401.7648621c0-85.5669556,71.8565063-150.2074738,180.2475281-158.6018829l11.8323364-56.4827423c1.1200562-5.3451996,5.8311157-9.1730957,11.2880859-9.1730957h89.1287842c7.3521118,0,12.8261108,6.7937469,11.2711792,13.9854736l-13.7007446,63.2864838c46.6417236,14.3664398,84.6193848,40.0598602,108.2597656,71.7617645c3.6638794,4.9127502,2.7211914,11.8712158-2.0166016,15.7610779l-57.6091309,47.2758789c-5.0075073,4.1085205-12.3158569,3.2119446-16.385498-1.8270874c-29.279541-36.2429199-75.3746338-56.724762-125.3060913-56.724762c-55.6435852,0-90.2319336,24.0825806-90.2319336,58.6976013C430.2033691,418.3204041,457.2720032,433.3720398,539.9865723,451.4339294z';

const AfterpayBadgeIcon: React.FC<AfterpayBadgeIconProps> = ({
  width = 38,
  height = 24,
  selected: _selected,
  ...props
}) => (
  <Svg width={width} height={height} viewBox="0 0 38 24" fill="none" {...props}>
    <Rect width="38" height="24" rx="3" fill={AFTERPAY_GREEN} />
    <Path
      d={DOLLAR_GLYPH_PATH}
      fill="#FFFFFF"
      transform="translate(8.3696 1.1512) scale(0.021682)"
    />
  </Svg>
);

AfterpayBadgeIcon.displayName = 'AfterpayBadgeIcon';
export { AfterpayBadgeIcon };
